import SubscriptionCheckoutForm from "./SubscriptionCheckoutForm";
import React, {useEffect} from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import ProductPreview from "../product-preview.png" 
import FestivLogo from "../festiv-logo.png"
import api from "../api";
import "../App.css";
import Footer from "./Footer"
import SignedOutNavbar from "./signed-out-navbar"

const stripePromise = api.getPublicStripeKey().then(key => loadStripe(key));

export default function SubscriptionCheckoutPage(props) {
  
    return(
        <div>

        <div className="App" >
        <div style = {{display: "block"}}>
        <a href="https://festivmedia.com/sign-up" className="back-to-account-link w-inline-block" style ={{padding: "20px", display: "inline-block", marginLeft: "8%", borderRadius:"8px"}}>
        <div className="html-embed-6 w-embed"><svg width="20" height="18" viewBox="0 0 12 8" fill="#d5e5ff" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 3.33333H2.55333L4.94 0.94L4 0L0 4L4 8L4.94 7.06L2.55333 4.66667H12V3.33333Z" fill="#d5e5ff"></path>
          </svg></div>
        <div style = {{marginTop: "30px", fontSize: "25px", color: "white"}}className="back-to-account-text">Back</div>
      </a>
      </div>
      

        <div style ={{paddingTop: "25px", marginLeft: "0px", marginRight:"0px", marginTop:"20px", marginBottom: "80px"}}className= "section-10">
          <Elements stripe={stripePromise}>
            <SubscriptionCheckoutForm subscriptionType = {props.subscriptionType}/>
          </Elements>
          </div>

    </div>
    </div>
    ) 
} 